import { MAX_LEAD_RATE } from '../constants';

export const hasValue = (item) => {
  if (!item.honorary) return false;
  
  // Handle both string and number values
  const numericValue = typeof item.honorary === 'string' ? parseFloat(item.honorary) : item.honorary;
  
  return !isNaN(numericValue) && numericValue > 0;
};

export const hasSource = (item) => {
  return Boolean(item.source);
};

export const hasCompanyType = (item) => {
  return Boolean(item.company_type);
};

export const hasNecessity = (item) => {
  return Boolean(item.necessity);
};

export const isRevised = (item) => {
  const additionalDataRevised = item.additional_data && Boolean(item.additional_data.is_revised);
  const itemRevised = Boolean(item.is_revised);
  return additionalDataRevised || itemRevised;
};

export const hasPercentage = (item) => {
  return Boolean(item.percentage);
};

export const hasRate = (item) => {
  const rate = Number(item.rate);
  return rate >= 1 && rate <= MAX_LEAD_RATE;
};

export const isFromFormColumn = (columnId) => {
  return columnId === 'form';
};